import React, { PureComponent } from 'react'
import { Redirect, Link } from "react-router-dom";
import { withRouter } from 'react-router'
import {
  Button,
  Row,
  Col,
  Input,
  Layout,
  Form,
  Alert,
  Modal,
  message,
  Switch,
  Tabs,
  notification
} from 'antd';
import '@ant-design/compatible/assets/index.css'

import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Config from "../Config"; //'../../Config';
import { Helmet } from "react-helmet";

import { connect } from 'react-redux';
import {
  setConfig,
  ajaxHandler,
  ajaxViewHandler
} from "../store/actions"; // "../../store/actions";

import axios from 'axios';
import Cookies from 'js-cookie';
import QRCode from 'qrcode.react';
import $ from 'jquery'

import 'antd/dist/antd.css';
import HeaderLayout from "../layouts/HeaderLayout";//'./HeaderInternalLayout';
import MenuLayout from "../layouts/MenuLayout"; //'./MenuInternalLayout';

import DashboardPusatData from "../pages/DashboardPusatData"; //'../../page/internal/dashboard/DashboardVerifikator';

class MainPageLayout extends PureComponent {
  config;
  // timeoutGetQr;
  // timeOutPushQr;

  constructor(props) {
    super(props);
    this.config = new Config();
    this.state = {
      msg: '',
      loading: false,
      loadingRedirect: false,
      logo: this.config.get_site_info().logo
    }
  }

  // jQuerycode = () =>{


  // }

  UNSAFE_componentWillMount() {
    document.body.className = "vertical-layout vertical-compact-menu 2-columns   fixed-navbar";

    document.body.setAttribute("data-open", "click");
    document.body.setAttribute("data-menu", "vertical-compact-menu");
    document.body.setAttribute("data-col", "2-columns");
  }

  initScript() {
    const script2 = document.createElement("script");
    script2.src = process.env.PUBLIC_URL + "/assets/js/app-menu.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = process.env.PUBLIC_URL + "/assets/js/app.js";
    script3.async = true;
    document.body.appendChild(script3);
  }

  componentDidMount() {
    this.initScript();

    // const panes = new Array(2).fill(null).map((_, index) => {
    //   const id = String(index + 1);
    //   return { title: `Tab ${id}`, content: `Content of Tab Pane ${id}`, key: id };
    // });
    // alert(JSON.stringify(panes));

    var tempTabs = this.props.tabs;
    tempTabs = [...tempTabs, {
      title: 'HOME',
      content: <DashboardPusatData />,
      key: "beranda",
    }]
    // tempTabs = [...tempTabs, {
    //     title: 'Pendaftaran RPK Liner',
    //     content: <PendaftaranRpkLinear />,
    //     key: "2",
    // }]
    this.props.setConfig({
      tabs: tempTabs,
      activeKey: "beranda"
    });
    // var that = this;
    // setTimeout(function(){
    //     that.props.setConfig({
    //         activeKey: "newTab1"
    //     });
    // }, 3000);
    window.addEventListener("popstate", e => {
      // Nope, go back to your page
      this.props.history.go(1);
    });

  }

  onEdit = (targetKey, action) => {
    // this[action](targetKey);
    if (action === 'add') {

    } else {
      this.remove(targetKey);
    }
  };

  onChange = activeKey => {
    this.props.setConfig({ activeKey });
  };

  remove = targetKey => {
    if (targetKey.toLowerCase() == "beranda") {
      notification.warning({
        message: "aksi ditolak",
        description: "maaf tab Beranda tidak dapat ditutup",
        placement: "bottomRight",
      });
    } else {
      if (targetKey.toLowerCase() != "beranda") {
        var tempTabs = this.props.tabs;

        const index_cari = tempTabs.findIndex((data) => data.key == targetKey);
        var activeKey = "";
        if (index_cari != -1) {
          activeKey = tempTabs[index_cari - 1].key
          tempTabs.splice(index_cari, 1);
        }
        // alert(activeKey);
        this.props.setConfig({
          tabs: tempTabs,
          activeKey: activeKey
        });
      }

    }
  };

  render() {
    // if (this.props.isLogin == false) {
    //   Cookies.remove(this.config.get_cookie_name());
    //   window.location.href = "/auth-internal"
    //   // return <Redirect to="/aut" />
    // }

    return (
      <>
        <Helmet>
          <title>Dashboard | {this.config.get_site_info().name}</title>
          <link rel="stylesheet" type="text/css" href={process.env.PUBLIC_URL + "/assets/css/menu/vertical-compact-menu.css"} />
          {/*<link rel="stylesheet" type="text/css" href={process.env.PUBLIC_URL + "/assets/css/pages/dashboard-ecommerce.css"} />*/}

        </Helmet>

        <HeaderLayout />
        <MenuLayout />


        {/*<!-- BEGIN: Content-->*/}
        <div className="app-content content">
          <div className="content-overlay"></div>
          <div className="content-wrapper">
            <div className="content-header row">
            </div>
            <div className="content-body">
              {/*<!-- Button Tab -->*/}
              {/*<div className="row">
                        <div className="col-12">
                            <div id="card-tab" className="card card-tab">
                                <div className="card-content">
                                    <div className="card-body p-0">
                                        <a className="btn round mb-1 active" id="beranda">Beranda</a>
                                        <a className="btn round mb-1" id="permohonan" style={{"display": "none"}}>Pendaftaran RPK Liner
                                            <span><i className="la la-close"></i></span></a>
                                        <a className="btn round mb-1" id="endorsement" style={{"display": "none"}}>Endorsement Perusahaan <span><i
                                                    className="la la-close"></i></span></a>
                                        <a className="btn round mb-1" id="perubahan" style={{"display": "none"}}>Perubahan Data
                                            Perusahaan <span><i className="la la-close"></i></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>                    
                    </div>*/}
              {/*<!-- End Button Tab -->*/}
              {this.props.tabs.length == 0
                ?
                <div className="row tab-content" style={{ height: 500 }}>
                  <div className="col-12" id="pengumuman">
                    <div className="row">
                      <div className="col-12">
                        <div className="content-header row">
                          <div className="content-header-left col-12">
                            <h3 className="content-header-title mb-0 text-bold-600">Tabs Kosong</h3>
                            <hr />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-content">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-12 text-center">
                                  belum ada tab terbuka, silahkan pilih menu yang diinginkan melalui panel disamping
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                :
                <Tabs
                  hideAdd
                  onChange={this.onChange}
                  activeKey={this.props.activeKey}
                  type="editable-card"
                  onEdit={this.onEdit}
                >
                  {this.props.tabs.map((pane, idx) => (
                    <Tabs.TabPane tab={pane.title} key={pane.key}>
                      {pane.content}
                    </Tabs.TabPane>
                  ))}
                </Tabs>
              }

            </div>
          </div>
        </div>





        <div className="sidenav-overlay"></div>
        <div className="drag-target"></div>

      </>
    )
  }
}

const mapStateToProps = function (state) {
  return state.configReducers
}

export default connect(mapStateToProps,
  {
    setConfig,
    ajaxHandler,
    ajaxViewHandler
  }
)(withRouter(MainPageLayout));
